import React from 'react';

import { formatCurrency, formatNumber, getMailSummaryViewModel } from '../../utils';

const MailSummary = ({ mailData, isLoading }) => {
  const summary = getMailSummaryViewModel(mailData);
  const statusTotal = summary.mailPiecesSent;
  const spendModeLabel = `${formatNumber(statusTotal)} mailpieces sent`;

  return (
    <section className="summary-grid" aria-label="Mail summary">
      <article className="spend-card">
        <span>Total spend</span>
        <strong>{isLoading ? '-' : formatCurrency(mailData?.spend)}</strong>
        <small>{spendModeLabel}</small>
      </article>

      <article className="dashboard-card delivery-status-card">
        <div className="card-heading">
          <h2>Mail delivery status</h2>
          <span>
            of <strong>{formatNumber(statusTotal)}</strong> sent
          </span>
        </div>
        <div className="delivery-bar" aria-label="Mail delivery status breakdown">
          {summary.delivered > 0 && (
            <span
              className="delivered"
              style={{ width: `${summary.deliveredPercent}%` }}
              title={`Delivered ${summary.deliveredPercent.toFixed(1)}%`}
            >
              {summary.deliveredPercent >= 18
                ? `Delivered ${Math.round(summary.deliveredPercent)}%`
                : ''}
            </span>
          )}
          {summary.inTransit > 0 && (
            <span
              className="in-transit"
              style={{ width: `${summary.transitPercent}%` }}
              title={`In transit ${summary.transitPercent.toFixed(1)}%`}
            />
          )}
          {summary.mailed > 0 && (
            <span
              className="mailed"
              style={{ width: `${summary.mailedPercent}%` }}
              title={`Mailed ${summary.mailedPercent.toFixed(1)}%`}
            />
          )}
          {summary.returned > 0 && (
            <span
              className="returned"
              style={{ width: `${summary.returnedPercent}%` }}
              title={`Returned ${summary.returnedPercent.toFixed(1)}%`}
            />
          )}
        </div>
        <div className="delivery-legend">
          <span>
            <i className="legend-dot delivered" />
            Delivered <strong>{formatNumber(summary.delivered)}</strong>
          </span>
          <span>
            <i className="legend-dot in-transit" />
            In transit <strong>{formatNumber(summary.inTransit)}</strong>
          </span>
          <span>
            <i className="legend-dot mailed" />
            Mailed <strong>{formatNumber(summary.mailed)}</strong>
          </span>
          <span>
            <i className="legend-dot returned" />
            Returned <strong>{formatNumber(summary.returned)}</strong>
          </span>
        </div>
      </article>
    </section>
  );
};

export default MailSummary;
